export function Note(props: { children: React.ReactNode }) {
	return (
		<div>
			<p className="note">{props.children}</p>
		</div>
	);
}
